import React, { useState, useEffect } from 'react';
import { Button, Card, Modal, Table, Row, Col, Form, Pagination, Container } from 'react-bootstrap';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { var_api } from '../../constant';
import Swal from "sweetalert2";
import Loader from "../Loader";

const AppointmentCouponList = () => {
  const [clientsData, setClientsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(25);
  const [startDate, setStartDate] = useState(getFormattedDate(30));
  const [endDate, setEndDate] = useState(getFormattedDate(0));
  const [popupLast30Days, setPopupLast30Days] = useState(false);
  const [popupServiceDetails, setPopupServiceDetails] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    fetchClients();
  }, [startDate, endDate]);

  function getFormattedDate(daysBeforeToday) {
    const date = new Date();
    date.setDate(date.getDate() - daysBeforeToday);
    return date.toISOString().split('T')[0];
  }

  const fetchClients = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const response = await axios.get(
        `${var_api}/api/booking/coupon-list-reports/${formattedStartDate}/${formattedEndDate}`,
        { headers: { Authorization: `${token}` } }
      );
      setClientsData(response.data);
      setPopupLast30Days(false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };

  const formatToDDMMYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

 const filteredUsers = clientsData.filter((client) => {
  const searchLower = searchQuery.toLowerCase();
  
  return (
    (client.booking_type === 1 ? 'Instant Booking' : client.booking_type === 2 ? 'Advanced Booking' : 'Unknown')
      .toLowerCase()
      .includes(searchLower) ||
    client.customer_name?.toLowerCase().includes(searchLower) ||
    client.customer_mobile?.toLowerCase().includes(searchLower) ||
    client.booking_date?.toLowerCase().includes(searchLower) ||
    client.booking_time?.toLowerCase().includes(searchLower) ||
    client.slot_time?.toLowerCase().includes(searchLower) ||
    client.total_amount?.toString().toLowerCase().includes(searchLower) ||
    client.transaction_id?.toLowerCase().includes(searchLower) ||
    client.payment_status?.toString().toLowerCase().includes(searchLower) ||
    client.status?.toString().toLowerCase().includes(searchLower) ||
    client.emp_name?.toLowerCase().includes(searchLower) ||
    client.role?.toLowerCase().includes(searchLower) ||
    (client.is_discount === 1
      ? client.discount?.toString().toLowerCase()
      : client.price?.toString().toLowerCase()
    ).includes(searchLower) ||
    client.date?.toLowerCase().includes(searchLower)
  );
});


  const totalPages = Math.ceil(filteredUsers.length / pageSize);
  const paginatedUsers = filteredUsers.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const handleShowServiceDetails = (services) => {
    setServiceData(services);
    setPopupServiceDetails(true);
  };

  const convertTo12Hour = (timeString) => {
    let [hours, minutes] = timeString.split(':');
    hours = parseInt(hours, 10);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${ampm}`;
  };

  const downloadCombinedExcel = () => {
    const appointmentSheet = paginatedUsers.map((client, index) => ({
      "S.No": index + 1,
      "Booking Type": client.booking_type === 1 ? 'Instant Booking' : client.booking_type === 2 ? 'Advanced Booking' : 'Unknown',
      "Customer Name": client.customer_name,
      "Customer Mobile": client.customer_mobile,
      "Booking Date": client.booking_date,
      "Booking Time": convertTo12Hour(client.booking_time),
      "Slot Time": client.slot_time,
      "Total Amount": client.total_amount,
      "Transaction ID": client.transaction_id,
      "Payment Status": client.payment_status,
      Status: client.status,
      "Employee Name": client.emp_name,
      Role: client.role,
      "Discounted Price": client.is_discount === 1 ? client.discount : client.price,
      "Booking Created Date": client.date,
      "Number of Services": client.services.length,
    }));

    const servicesSheet = paginatedUsers.flatMap(client =>
      client.services.map((service, index) => ({
        "S.No": index + 1,
        "Service Name": service.service_name,
        "From Time": convertTo12Hour(service.from_time),
        "To Time": convertTo12Hour(service.to_time),
        "Duration": service.duration,
        "Price": service.price,
      }))
    );

    const appointmentWs = XLSX.utils.json_to_sheet(appointmentSheet);
    const servicesWs = XLSX.utils.json_to_sheet(servicesSheet);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, appointmentWs, "Coupon Appointments");
    XLSX.utils.book_append_sheet(wb, servicesWs, "Services");

    XLSX.writeFile(wb, "coupon_appointments.xlsx");
  };

  return (
    <>
     {loading && <Loader />} 
    <Container className="activity-container mx-auto">
          <Button variant="dark" onClick={() => history.push('/reports')} className="mb-4">
            <i className='bx bx-arrow-back'></i> Back
          </Button>
          <h2 className="mb-4 text-center">Appointment Coupon List</h2>
          <p className="mb-4 text-center">Comprehensive list of all active appointment coupon list.</p>

          <div className="filters mb-4 d-flex justify-content-between">
    <Button variant="dark" onClick={() => setPopupLast30Days(true)}>Date Filter</Button>
    <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search"
            style={{ width: '200px' }} // Adjust width as needed
        />
  </div>

          <Modal show={popupLast30Days} onHide={() => setPopupLast30Days(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Filter Last 30 Days</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-4">
                <Col>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Col>
                <Col>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Col>
              </Row>
              <Button variant="dark" onClick={fetchClients}>Apply</Button>
              <Button variant="outline-secondary" onClick={() => setPopupLast30Days(false)} className="ms-2">Cancel</Button>
            </Modal.Body>
          </Modal>

          {/* <div className="d-flex justify-content-end mb-4">
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search"
            />
          </div> */}

          <Table responsive bordered hover className="text-center">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Booking Type</th>
                <th>Customer Name</th>
                <th>Customer Mobile</th>
                <th>Booking Date</th>
                <th>Booking Time</th>
                <th>Slot Time</th>
                <th>Total Amount</th>
                <th>Transaction Id</th>
                <th>Payment Status</th>
                <th>Status</th>
                <th>Emp Name</th>
                <th>Role</th>
                <th>Is Discount</th>
                <th>Date</th>
                <th>Services</th>
              </tr>
            </thead>
            <tbody>
              {paginatedUsers.length > 0 ? (
                paginatedUsers.map((client, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{client.booking_type === 1 ? 'Instant Booking' : client.booking_type === 2 ? 'Advanced Booking' : 'Unknown'}</td>
                    <td>{client.customer_name}</td>
                    <td>{client.customer_mobile}</td>
                    <td>{client.booking_date}</td>
                    <td>{convertTo12Hour(client.booking_time)}</td>
                    <td>{client.slot_time}</td>
                    <td>{client.total_amount}</td>
                    <td>{client.transaction_id}</td>
                    <td>{client.payment_status}</td>
                    <td>{client.status}</td>
                    <td>{client.emp_name}</td>
                    <td>{client.role}</td>
                    <td>{client.is_discount === 1 ? client.discount : client.price}</td>
                    <td>{client.date}</td>
                    <td>
                      <Button variant="dark" onClick={() => handleShowServiceDetails(client.services)}>
                        Services ({client.services.length})
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="16" className="text-center">No Data Available</td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className='d-flex justify-content-between align-items-center mt-4'>
          <Button variant="dark" onClick={downloadCombinedExcel} className="mt-4">
            Download as Excel
          </Button>

          <Pagination className="mt-4">
            <Pagination.Prev onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>Previous</Pagination.Prev>
            {[...Array(totalPages).keys()].map((_, idx) => (
              <Pagination.Item key={idx} active={currentPage === idx + 1} onClick={() => setCurrentPage(idx + 1)}>
                {idx + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}>Next</Pagination.Next>
          </Pagination>
          </div>

      <Modal show={popupServiceDetails} onHide={() => setPopupServiceDetails(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Services</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table responsive bordered hover className="text-center">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Service Name</th>
                <th>From Time</th>
                <th>To Time</th>
                <th>Duration</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {serviceData.length > 0 ? (
                serviceData.map((service, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{service.service_name}</td>
                    <td>{convertTo12Hour(service.from_time)}</td>
                    <td>{convertTo12Hour(service.to_time)}</td>
                    <td>{service.duration}</td>
                    <td>{service.price}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No Data Available</td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </Container>
    </>
  );
};

export default AppointmentCouponList;
